import { adminT } from '@/i18n/adminCommon'

export const SYSTEM_MESSAGES = {
  de: {
    title: 'System',
    intro: 'Übersicht der Systeminformationen sowie Werkzeuge für DB-Dumps und Schema-Abgleich.',

    dumpsTitle: 'Datenbank-Dumps',
    dumpsIntro: 'Dump erstellen und herunterladen. Nur für die IT.',
    dumpQuickTitle: 'Schnell-Dump',
    dumpQuickHint: 'Vollständig oder Slim (ohne Changes-Tabelle).',
    dumpCreate: 'Dump erstellen',
    dumpCreateSlim: 'Dump erstellen (Slim)',
    dumpCustomTitle: 'Individueller Dump',
    dumpTablesLabel: 'Tabellen',
    dumpTablesHint: 'Nur die ausgewählten Tabellen werden exportiert.',
    dumpSelectedCount: '{n} ausgewählt',
    dumpCreateCustom: 'Auswahl dumpen',
    dumpsHistoryTitle: 'Bisherige Dumps',
    dumpsEmptyTitle: 'Noch keine Dateien',
    dumpsEmpty: 'Erstellte Dumps erscheinen hier zum Download.',
    dumpsColName: 'Name',
    dumpsColSize: 'Größe',
    dumpsColDate: 'Erstellt',
    dumpsColDownload: 'Download',
    download: 'Download',

    schemaTitle: 'Datenbank-Schema',
    schemaIntro: 'Zeigt ausstehende Doctrine-Schema-Änderungen und kann sie anwenden. Nach Deployments nutzen, wenn Entity und DB auseinanderlaufen (z.B. neue Spalten).',
    schemaStep1: 'SQL Preview laden und prüfen',
    schemaStep2: 'Optional validieren',
    schemaStep3: 'Schema anwenden, wenn die Preview stimmt',
    schemaStepHint: 'Nutzt schema:update --complete (DBAL-4-konform).',
    schemaPreview: 'SQL Preview',
    schemaValidate: 'Validieren',
    schemaApply: 'Schema anwenden',
    schemaApplyLocked: 'Anwenden ist erst nach erfolgreicher Preview aktiv.',
    schemaReady: 'Preview bereit — SQL prüfen, dann anwenden.',
    schemaLockKeysTitle: 'Hinweis zu lock_keys',
    schemaLockKeysBody: 'lock_keys (Symfony Lock für ES-/SF-Sync) ist über doctrine.dbal.schema_filter aus dem Schema-Tool ausgeklammert. Preview/Apply nutzen --complete, ohne DROP TABLE lock_keys zu erzeugen.',
    schemaOutputTitle: 'SQL-Ausgabe',
    schemaPreviewTitle: 'Schema Preview',
    schemaValidateTitle: 'Schema Validate',
    schemaApplyTitle: 'Schema Update',
    schemaLoadingPreview: 'Lade Preview…',
    schemaNoPreviewYet: 'Noch keine Preview. Bitte „SQL Preview“ klicken.',
    schemaNoChanges: '(keine ausstehenden Änderungen)',
    schemaRequestFailed: 'Anfrage fehlgeschlagen',
    schemaConfirmTitle: 'Schema wirklich anwenden?',
    schemaConfirmBody: 'Die Preview-SQL wird auf der aktuellen Datenbank ausgeführt. Nur fortfahren, wenn die Preview korrekt aussieht.',

    infoTitle: 'Systeminformationen',
    infoIntro: 'Laufzeit- und Umgebungswerte der aktuellen Instanz.',
    infoColName: 'Name',
    infoColValue: 'Wert',
    vueTimeout: 'Vue Timeout (Sekunden)'
  },
  en: {
    title: 'System',
    intro: 'Overview of system information plus tools for DB dumps and schema sync.',

    dumpsTitle: 'Database dumps',
    dumpsIntro: 'Create and download dumps. IT only.',
    dumpQuickTitle: 'Quick dump',
    dumpQuickHint: 'Full dump or slim (excludes the Changes table).',
    dumpCreate: 'Create dump',
    dumpCreateSlim: 'Create dump (slim)',
    dumpCustomTitle: 'Custom dump',
    dumpTablesLabel: 'Tables',
    dumpTablesHint: 'Only the selected tables are exported.',
    dumpSelectedCount: '{n} selected',
    dumpCreateCustom: 'Dump selection',
    dumpsHistoryTitle: 'Previous dumps',
    dumpsEmptyTitle: 'No files yet',
    dumpsEmpty: 'Created dumps will show up here for download.',
    dumpsColName: 'Name',
    dumpsColSize: 'Size',
    dumpsColDate: 'Created',
    dumpsColDownload: 'Download',
    download: 'Download',

    schemaTitle: 'Database schema',
    schemaIntro: 'Shows pending Doctrine schema changes and can apply them. Use after deployments when entities and the DB diverge (e.g. new columns).',
    schemaStep1: 'Load and review SQL Preview',
    schemaStep2: 'Optionally validate',
    schemaStep3: 'Apply schema when the preview looks right',
    schemaStepHint: 'Uses schema:update --complete (DBAL 4 ready).',
    schemaPreview: 'SQL Preview',
    schemaValidate: 'Validate',
    schemaApply: 'Apply schema',
    schemaApplyLocked: 'Apply unlocks only after a successful preview.',
    schemaReady: 'Preview ready — review the SQL, then apply.',
    schemaLockKeysTitle: 'About lock_keys',
    schemaLockKeysBody: 'lock_keys (Symfony Lock for ES/SF sync) is excluded from the schema tool via doctrine.dbal.schema_filter. Preview/Apply use --complete without emitting DROP TABLE lock_keys.',
    schemaOutputTitle: 'SQL output',
    schemaPreviewTitle: 'Schema Preview',
    schemaValidateTitle: 'Schema Validate',
    schemaApplyTitle: 'Schema Update',
    schemaLoadingPreview: 'Loading preview…',
    schemaNoPreviewYet: 'No preview yet. Click “SQL Preview”.',
    schemaNoChanges: '(no pending changes)',
    schemaRequestFailed: 'Request failed',
    schemaConfirmTitle: 'Apply schema now?',
    schemaConfirmBody: 'The preview SQL will run against the current database. Continue only if the preview looks correct.',

    infoTitle: 'System information',
    infoIntro: 'Runtime and environment values for the current instance.',
    infoColName: 'Name',
    infoColValue: 'Value',
    vueTimeout: 'Vue timeout (seconds)'
  }
}

export function systemT (lang, key) {
  return adminT(SYSTEM_MESSAGES, lang, key)
}
